var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "askgoover", "data-size": "1x1" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _c("div", { staticClass: "go-card-body" }, [
          _c("div", { staticClass: "go-block-header" }, [
            _c("div", { staticClass: "go-card-header" }, [
              _c(
                "a",
                {
                  staticClass: "go-card-title go-card-title__cus",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.viewHistory.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-block-body" }, [
            _c("div", { staticClass: "go-block-wrap" }, [
              _c("div", { staticClass: "go-card-desc" }, [
                _vm._v(_vm._s(_vm.description)),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "go-card-info",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.navigateChat(_vm.chatPage, _vm.conversationId)
                    },
                  },
                },
                [
                  _c("span", [_c("i", { class: _vm.getIcon(_vm.type) })]),
                  _vm._v(" "),
                  _c("ins", [_vm._v(_vm._s(_vm.linkTitle))]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-block-footer" }, [
            _c("div", { staticClass: "go-card-info" }, [
              _c("span", { staticClass: "go-info-item go-datetime" }, [
                _c("em", { staticClass: "go-text" }, [
                  _vm._v(_vm._s(_vm.getDate(_vm.date))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-btn-area" }, [
              _c("div", { staticClass: "dropdown" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: { click: _vm.addBookmark },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-18",
                          class: _vm.isBookmark
                            ? "go-icon-bookmark-on"
                            : "go-icon-bookmark-line",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.isBookmark
                                ? _vm.$t("my-create.ask-goover.un-bookmark")
                                : _vm.$t("my-create.ask-goover.bookmark")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.share(_vm.conversationId)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "go-icon-20 go-icon-share" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-text" }, [
                          _vm._v(_vm._s(_vm.$t("my-create.ask-goover.share"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.deleteChatHistory(_vm.conversationId)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "go-icon-20 go-icon-hidden" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-text" }, [
                          _vm._v(_vm._s(_vm.$t("briefing.comment.remove"))),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-card-icon" }, [
      _c("i", { staticClass: "go-icon-24 go-icon-comment" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn go-btn-icon",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-more-dot" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }